// Context storing the active Home backdrop tint so Header can mirror color changes while Home scrolls.

import React, {
  createContext,
  useMemo,
  useState,
  type Dispatch,
  type SetStateAction,
} from 'react';
import type { PlayerColorFamily } from '@/styles/playerColors';

export type HomeNavAccentContextValue = {
  activeColorFamily: PlayerColorFamily | null;
  setActiveColorFamily: Dispatch<SetStateAction<PlayerColorFamily | null>>;
};

export const HomeNavAccentContext =
  createContext<HomeNavAccentContextValue | null>(null);

export function HomeNavAccentProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [activeColorFamily, setActiveColorFamily] =
    useState<PlayerColorFamily | null>(null);

  const value = useMemo(
    () => ({ activeColorFamily, setActiveColorFamily }),
    [activeColorFamily]
  );

  return (
    <HomeNavAccentContext.Provider value={value}>
      {children}
    </HomeNavAccentContext.Provider>
  );
}
